import {reactive, inject} from "vue";

class Modal {
    _list = reactive([]);

    open(component, props = {}, options = {}) {
        Object.assign(props, {
            id: props.id ||  Math.floor(Math.random() * 100),
        });

        const index = this._list.findIndex(m => m.props.id === props.id);
        if (index !== -1) return;

        this._list.push({
            component,
            props,
            options
        });
    }

    all() {
        return this._list;
    }

    close(id) {
        const index = this._list.findIndex(modal => modal.props.id === id);
        if (index === -1) return;
        this._list.splice(index, 1);
    }

    closeAll() {
        this._list.splice(0);
    }
}

export const modal = new Modal();

export default {
    install(app) {
        app.config.globalProperties.$modal = (component, props, options) => {
            if (typeof component === 'string') {
                modal.close(component);
                return;
            }
            modal.open(component, props, options);
        };
        app.config.globalProperties.$modalClose = modal.close.bind(modal);
        app.provide('modal', modal);
    }
}

export function useModal() {
    return inject('modal');
}